import React from 'react';
import { EmptyText } from 'library/ui';

const Error = () => {
    return <EmptyText>Something went wrong. Please reach out to support.</EmptyText>;
};

export default Error;
